// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__38jJY","left":"StickyBox_left__gI2sC","right":"StickyBox_right__2YmYF"};